import React, { useState } from "react";
import { Navbar, Nav, NavDropdown, Badge, Modal, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import { logout } from "../actions/userActions";

const TopNavBar = () => {
  const userLogin = useSelector((state) => state.userLogin);

  const { userInfo } = userLogin;
  const dispatch = useDispatch();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const role = userInfo?.role || 'user';

  const logoutHandler = () => {
    dispatch(logout());
  };

  const getRoleBadgeVariant = (role) => {
    switch (role) {
      case 'admin': return 'danger';
      case 'lab': return 'info';
      default: return 'secondary';
    }
  };

  return (
    <header>
      {userInfo && (
        <Navbar
          className="custom-top-boxshadow"
          fixed="top"
          collapseOnSelect
          expand="lg"
          variant="light"
        >
          <LinkContainer to="/">
            <Navbar.Brand>Ji-Billing</Navbar.Brand>
          </LinkContainer>
          <Badge pill variant={getRoleBadgeVariant(role)} className="ml-2" style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>
            {role}
          </Badge>
          {/* Mobile logout — icon only, visible on small screens */}
          <Nav className="ml-auto d-flex d-md-none align-items-center" style={{ gap: '8px' }}>
            {userInfo && (
              <Nav.Link onClick={() => setShowLogoutConfirm(true)} style={{ padding: '4px 8px', color: '#64748b' }} title="Logout">
                <i className="fa fa-sign-out fa-lg"></i>
              </Nav.Link>
            )}
          </Nav>
          {/* Desktop nav — user dropdown */}
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ml-auto d-none d-md-block" style={{ float: 'right' }}>
              {userInfo ? (
                <NavDropdown title={userInfo.name} id="username">
                  <NavDropdown.Item onClick={logoutHandler}>
                    Logout
                  </NavDropdown.Item>
                </NavDropdown>
              ) : (
                <LinkContainer to="/login">
                  <Nav.Link>Sign In</Nav.Link>
                </LinkContainer>
              )}
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      )}

      {/* Mobile Logout Confirmation Modal */}
      <Modal
        show={showLogoutConfirm}
        onHide={() => setShowLogoutConfirm(false)}
        centered
        size="sm"
      >
        <Modal.Body className="text-center" style={{ padding: '2rem 1.5rem' }}>
          <div style={{
            width: '56px', height: '56px', borderRadius: '50%',
            background: '#fef2f2', display: 'flex', alignItems: 'center',
            justifyContent: 'center', margin: '0 auto 1rem'
          }}>
            <i className="fa fa-sign-out" style={{ fontSize: '1.4rem', color: '#ef4444' }}></i>
          </div>
          <h6 style={{ fontWeight: 700, color: '#1e293b', marginBottom: '0.4rem' }}>Logout?</h6>
          <p style={{ fontSize: '0.85rem', color: '#64748b', marginBottom: '1.5rem' }}>
            Are you sure you want to log out?
          </p>
          <div className="d-flex" style={{ gap: '10px' }}>
            <Button
              variant="light"
              className="w-50"
              style={{ borderRadius: '8px', fontWeight: 600, border: '1px solid #e2e8f0' }}
              onClick={() => setShowLogoutConfirm(false)}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              className="w-50"
              style={{ borderRadius: '8px', fontWeight: 600 }}
              onClick={logoutHandler}
            >
              Logout
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </header>
  );
};

export default TopNavBar;
